import { render, staticRenderFns } from "./BiomassMapList.vue?vue&type=template&id=cf0a79a0&scoped=true&lang=html&"
import script from "./BiomassMapList.vue?vue&type=script&lang=js&"
export * from "./BiomassMapList.vue?vue&type=script&lang=js&"
import style0 from "./BiomassMapList.vue?vue&type=style&index=0&id=cf0a79a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0a79a0",
  null
  
)

export default component.exports